module.exports = __webpack_public_path__ + "img/move28.5f82f63b.jpg";